<n-lv [simpleMode]="SWITCH.IS_SIMPLE_MODE">
    <n-lv-item [label]="i18n.currentVersion">
        {{currentVersion || UNPLACEHOLDER}}
    </n-lv-item>
    <!-- 更新组件包 -->
    <n-lv-item [label]="i18n.upgradeCheckFile" class="label-stretch">
        <n-radio-group
            [(ngModel)]="updateCheckFile">
            <n-radio id="update-script-true"
                [disabled]="!updateCheckFile && (currentProcess || uploadstatus)"
                [value]="true">{{i18n.updateLabel}}</n-radio>
            <n-radio id="update-script-false"
                [disabled]="updateCheckFile && (currentProcess || uploadstatus)"
                [value]="false">{{i18n.notUpdateLabel}}</n-radio>
        </n-radio-group>
    </n-lv-item>
    <n-lv-item [label]="i18n.checkFileLab" *ngIf="updateCheckFile">
        <app-upgrade-file-upload
            [restUrl]="checkFileUrl"
            accept=".gz"
            maxFileSize="10485760"
            [timeout]="310000"
            [disabled]="checkFileUploadDisabled | fn :currentProcess:uploadstatus"
            [getTargetVersion]="false"
            (onFileSelected)="selectCheckFile()"
            (onUploadStart)="startUploadCheckFile()"
            (onUploadCompelete)="checkFileUploadCompelete($event)"
            (onUploadFailed)="checkFileUploadFailed()">
        </app-upgrade-file-upload>
    </n-lv-item>
    <!-- 文件大小 700m  超时时间1小时10秒 -->
    <n-lv-item [label]="i18n.hotpatchPackage">
        <p-fileUpload
            #uploadEl
            [ngClass]="{'ca-upload-control':!isJa, 'ca-upload-control-ja': isJa }"
            [class.has-error]="uploadMsg"
            name="file[]"
            [url]="uploadUrl"
            accept=".tgz"
            allowFileSuffix=".tgz"
            maxFileSize="734003200"
            [timeout]="3610000"
            [uploadButtonVisible]="true"
            [disabled]="isUpgrading || (checkHotpatchUploadDisabled | fn :currentProcess:updateCheckFile)"
            (onSelect)="onSelectPatch($event, uploadEl, onSelect)"
            (onBeforeSend)="onBeforeSend($event)"
            (onBeforeUpload)="onBeforeUpload($event)"
            (onUpload)="onUpload($event)"
            (onError)="onError()">
        </p-fileUpload>
        <div class="" >
            <span *ngIf="uploadstatus === UPLOAD_STATUS.err">
                <!-- 上传失败信息 -->
                <n-tip *ngIf="uploadMsg && !distributeFail"
                    type="failed"
                    [content]="uploadMsg">
                </n-tip>
                <!-- 分发失败信息 -->
                <div class="dist-tip" *ngIf="distributeFail">
                    <svg class="dist-tip-icon">
                        <use xlink:href="#icon-status-failed"></use>
                    </svg>
                    <div class="dist-tip-text">
                        {{i18n.distFailTip}}
                        <span class="dist-tip-text-link" (click)="showUploadFailDetail()">{{i18n.clickShowDetail}}</span>
                    </div>
                </div>
            </span>
        </div>
        <div *ngIf="uploadstatus === UPLOAD_STATUS.ing && uploadProgressShow" style="margin-top:.1rem">
            <svg class="icon icon-status uploading"><use xlink:href="#icon-loading"/></svg>
            {{i18n.uploading}}
        </div>
        <div *ngIf="uploadstatus === UPLOAD_STATUS.suc && uploadProgressShow" style="margin-top:.1rem">
            <svg class="icon icon-status">
                <use xlink:href="#icon-status-succeed"></use>
            </svg>
            {{i18n.uploadsuc}}
        </div>
        <div class="upload-Progress" *ngIf="uploadProgressShow">
            <span>
                <p-progressBar [value]="uploadProgress"  [color]="progressColor"></p-progressBar>
            </span>
        </div>
    </n-lv-item>
    <n-lv-item [label]="i18n.targetVersion">
        {{targetVersion}}
    </n-lv-item>
    <n-lv-item *ngIf="isUpgrading" [labelHide]="true">
        <n-tip type="warning" [content]="i18n.upgradingTip"></n-tip>
    </n-lv-item>
</n-lv>
